<template>
  <div class="detail-download">
    <div class="product-info">
      <div class="product-banner">
        <img :src="detail.en_download_banner" alt="">
      </div>
      <div class="introduce">
        <h3>{{ detail.name }}</h3>
        <p>{{ detail.title_content }}</p>
      </div>
    </div>
    <div class="product-videos">
      <h3>Videos</h3>
      <div class="product-video-list">
        <div class="product-video-item" v-for="item in detail.en_video_data">
          <div class="video-cover" @click="openVideo(item,item.video)">
            <img :data-src="item.image" class="lazyload" alt=""/>
            <img class="icon-play" :src="require('@/assets/common/img/play.svg')" alt=""/>
          </div>
          <div class="product-video-info">
            <h4>{{ item.title }}</h4>
            <p>{{ item.desc }}</p>
<!--            <a href="javascript:void(0)" @click="downloadFile(item, item.title, item.video)" :class="{ active:item.active, dte: channel_id == 2 }" class="download-button">Download</a>-->
            <a href="javascript:void(0)" @click="downloadFile(item, item.title, item.video)" :class="{ dte: channel_id == 2 }" class="download-button">Download</a>
          </div>
        </div>
      </div>
    </div>

    <div class="product-brochures">
      <h3>Brochures</h3>
      <div class="product-brochures-list">
        <div class="product-brochures-item" v-for="item in detail.en_resource_data" @click.stop="openFile(item.resource)">
          <h4 class="line2">{{ item.title }}</h4>
          <p>{{ item.date }}</p>
<!--          <a href="javascript:void(0)" @click.stop="downloadFile(item, item.title, item.resource)" :class="{ active:item.active, dte: channel_id == 2 }" class="download-button">Download</a>-->
          <a href="javascript:void(0)" @click.stop="downloadFile(item, item.title, item.resource)" :class="{ dte: channel_id == 2 }" class="download-button">Download</a>
        </div>
      </div>
    </div>

    <div class="product-image">
      <h3>Image</h3>
      <div class="product-image-list">
        <div class="product-image-item" v-for="item in detail.en_images_data">
          <div class="product-image-item-image" @click.stop="openFile(item.image)">
            <img :data-src="item.image" class="lazyload" alt=""/>
          </div>
<!--          <a href="javascript:void(0)" @click="downloadImage(item, item.title, item.image)" :class="{ active:item.active, dte: channel_id == 2 }" class="download-button">Download</a>-->
          <a href="javascript:void(0)" @click="downloadFile(item, item.title, item.image)" :class="{ dte: channel_id == 2 }" class="download-button">Download</a>
        </div>
      </div>
    </div>
    <dialogVideo ref="dialogVideoRef" @downloadFile="downloadFile"></dialogVideo>
    <div class="layer" v-if="layerShow" @click="closeLayer">
      <div class="layer-container">
        <div class="img">
          <img :src="require('@/assets/common/img/top-arrow.png')" alt="">
        </div>
        <div class="txt">请点击右上角“...”，在菜单中选择“在浏览器中打开”，以完成下载</div>
      </div>
    </div>
  </div>
</template>

<script>
import dialogVideo from "./dialog-video.vue";
import {session} from "../../../storage/storage";

export default {
  name: 'detail-download',
  components: {
    dialogVideo
  },
  props: {
    detail: {
      type: Object,
      default: () => {}
    }
  },
  data(){
    return {
      channel_id: 1,
      layerShow: false,
    }
  },
  mounted() {
    this.channel_id = session.get('channel_id')
  },
  methods: {
    openFile(url){
      if(this.isWeChatBrowser()){
        this.layerShow = true
        return
      }
      window.open(url)
    },
    openVideo(item, url){
      this.$refs.dialogVideoRef.open(item.title,url)
    },
    // async downloadFile(item, name, path) {
    //   const url = path;
    //   const filename = name;
    //   const ext = url.split('.').pop()
    //   try {
    //     if(item){
    //       // item.active = true
    //       // this.$forceUpdate()
    //     }
    //     const response = await fetch(url);
    //     const blob = await response.blob();
    //     const downloadUrl = window.URL.createObjectURL(new Blob([blob]));
    //     const link = document.createElement('a');
    //     link.href = downloadUrl;
    //     link.setAttribute('download', filename + '.' + ext);
    //     document.body.appendChild(link);
    //     link.click();
    //     link.remove();
    //     window.URL.revokeObjectURL(downloadUrl);
    //
    //   } catch (err) {
    //     console.error('下载失败:', err);
    //   }
    // },
    closeLayer(){
      this.layerShow = false
    },
    async downloadFile(item, name, urlStr) {
      if(this.isWeChatBrowser()){
        this.layerShow = true
        return
      }
      const url = new URL(urlStr);
      const path = url.pathname.substring(1);
      const filename = name ? name : 'download';
      const ext = urlStr.split('.').pop()

      if(urlStr.includes('myqcloud.com')){
        this.$utils.handleDownloadUri(filename,urlStr)
        // let ext = urlStr.substring(urlStr.lastIndexOf('.') + 1);
        // if (urlStr.indexOf("https://") < 0) {
        //   urlStr = urlStr.replace("http://", "https://");
        // }
        // window.open(urlStr+'?download_name='+ filename + '.' + ext)
        // window.location.href = urlStr+'?download_name='+ filename + '.' + ext
      }else {
        this.$api.get_oss_sign_url({path:path,file_name: filename + '.' + ext}).then(async res => {
          // window.open(res.data)
          let uri = res.data
          let elt = document.createElement('a');
          elt.setAttribute('href', uri);
          elt.setAttribute('download', filename + '.' + ext);
          elt.style.display = 'none';
          document.body.appendChild(elt);
          elt.click();
          document.body.removeChild(elt);
        })
      }
    },
    isWeChatBrowser() {
      return /micromessenger/i.test(navigator.userAgent.toLowerCase());
    },
    downloadImage(item, name, path){
      item.active = true
      this.$forceUpdate()
      window.open(path)
    },
  }
}

</script>

<style scoped>

.line2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.detail-download {
  width: 100%;
  padding-bottom: .8rem;
}


.detail-download .download-button {
  width: 2.6rem;
  font-size: .26rem;
  color: #1b1b1b;
  cursor: pointer;
  border: 1px solid #1b1b1b;
  padding: .15rem 0;
  text-align: center;
  border-radius: 8px;
  transition: all .3s linear 0s;
  display: block;
  text-decoration: none;
}
.detail-download .download-button:active {
  background-color: #d10707;
  color: #ffffff;
  border: 1px solid #d10707;

}
.detail-download .download-button.active {
  background-color: #d10707;
  color: #ffffff;
  border: 1px solid #d10707;

}

.detail-download .download-button.dte:active {
  background-color: #1a4698!important;
  color: #ffffff;
  border: 1px solid #1a4698!important;

}
.detail-download .download-button.dte.active {
  background-color: #1a4698!important;
  color: #ffffff;
  border: 1px solid #1a4698!important;

}
.detail-download img {
  display: block;
  width: 100%;
  height: 100%;
}

.detail-download h2 {
  font-size: .35rem;
  color: #1b1b1b;
  font-weight: 500;
}
.detail-download h3 {
  font-size: .44rem;
  color: #1b1b1b;
  font-weight: 500;
}
.detail-download h4 {
  font-size: .36rem;
  font-weight: 500;
  color: #1b1b1b;
}
.detail-download p {
  color: #7d7d7d;
  font-size: .26rem;
  line-height: 1.6;
}
.product-info {}
.product-info .product-banner {}
.product-info .product-banner img {
  width: 100%;
}
.product-info .introduce {
  padding: .3rem .4rem 0 .4rem;
}
.product-info .introduce h3,
.product-videos .product-video-list .product-video-item .product-video-info h4 {
  padding-bottom: .2rem;
  font-weight: 500;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: keep-all;
}
.product-videos .product-video-list .product-video-item .product-video-info h4 {
  font-size: .3rem;
}
.product-videos .product-video-list .product-video-item .product-video-info p {
  font-size: .24rem;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: keep-all;
}
.detail-download .product-videos,
.detail-download .product-videos h3,
.detail-download .product-brochures,
.detail-download .product-brochures h3,
.detail-download .product-image,
.detail-download .product-image h3 {
  padding: 0 .2rem;
}
.detail-download .product-videos h3,
.detail-download .product-brochures h3,
.detail-download .product-image h3 {
  padding-top: 1.4rem;
  margin-bottom: .6rem;
}

.product-videos .product-video-list .product-video-item {
  margin-top: 1.2rem;
}
.product-videos .product-video-list .product-video-item:first-child {
  margin-top: 0;
}
.product-videos .product-video-list .product-video-item .video-cover {
  border-radius: 8px;
  overflow: hidden;
  position: relative;
}
.product-videos .product-video-list .product-video-item .video-cover .icon-play {
  width: 1.4rem;
  height: 1.4rem;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.product-videos .product-video-list .product-video-item .product-video-info {
  padding: .4rem .2rem 0 .2rem;
}

.product-videos .product-video-list .product-video-item .product-video-info .download-button {
  margin-top: .42rem;
}


.product-brochures .product-brochures-list,
.product-image .product-image-list {
  display: flex;
  flex-wrap: wrap;
}
.product-brochures .product-brochures-list .product-brochures-item {
  padding: .2rem;
  border-radius: 8px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  width: 3rem;
  margin-left: .3rem;
  margin-top: .3rem;
}
.product-brochures .product-brochures-list .product-brochures-item:nth-child(2n+1),
.product-image .product-image-list .product-image-item:nth-child(2n+1){
  margin-left: 0;
}
.product-brochures .product-brochures-list .product-brochures-item:first-child,
.product-brochures .product-brochures-list .product-brochures-item:nth-child(2){
  margin-top: 0;
}
.product-brochures .product-brochures-list .product-brochures-item h4 {
  font-size: .26rem;
  font-weight: 500;
  height: .7rem;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: keep-all;
}

.product-brochures .product-brochures-list .product-brochures-item .download-button,
.product-image .product-image-list .product-image-item .download-button {
  font-size: .2rem;
  width: 1.8rem;
  padding: .12rem 0;
}

.product-brochures .product-brochures-list .product-brochures-item p {
  margin: .2rem 0 .8rem 0;
  font-size: .22rem;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: keep-all;
}

.product-image .product-image-list .product-image-item {
  width: 3.45rem;
  margin-left: .2rem;
  margin-top: .6rem;
}

.product-image .product-image-list .product-image-item:first-child,
.product-image .product-image-list .product-image-item:nth-child(2){
  margin-top: 0;
}

.product-image .product-image-list .product-image-item .product-image-item-image {
  border-radius: 8px;
  overflow: hidden;
  width: 3.45rem;
  height: 2.1rem;

}

.product-image .product-image-list .product-image-item .product-image-item-image img{
  object-fit: cover;
  object-position: center;
  display: block;
}

.product-image .product-image-list .product-image-item .download-button {
  margin-top: .4rem;
  margin-left: .2rem;
}

.layer {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0,0,0, .7);
  top: 0;
  left: 0;
  z-index: 999999;
}
.layer .layer-container {

}
.layer .layer-container .txt {
  font-size: .36rem;
  color: #ffffff;
  text-align: center;
  padding: 0 .8rem;
  line-height: 2;
}
.layer .layer-container .img {
  padding-top: .2rem;
  display: flex;
  justify-content: right;
  align-items: center;
}
.layer .layer-container .img img {
  width: 1.5rem;
}
</style>
